import React from "react";
import { ConfigProvider, Card, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { LoginForm } from "../../../components/Admin/Auth/LoginForm/LoginForm";
// Importamos ambos logos para branding dual
import { logoEduca, LogoRevi } from "../../../assets";
import "./Auth.scss";

const { Text } = Typography;

export function Auth() {
  const { t } = useTranslation("misc");

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "'Inter', sans-serif",
        },
      }}
    >
      <div className="auth-container">
        {/* Capa de fondo con imagen y overlay */}
        <div className="auth-bg-layer" />

        <div className="auth-card-wrapper">
          <Card className="auth-card" bordered={false}>
            <div className="auth-header">
              {/* Logo REVI Principal. El alt es el nombre del producto, no
                  interfaz: se queda igual en todos los idiomas. */}
              <img
                src={LogoRevi.logoRevi}
                alt="REVI VR Therapy"
                className="auth-logo-main"
              />

              <div className="auth-subtitle">
                <Text type="secondary">{t("authPage.subtitle")}</Text>
              </div>
            </div>

            <LoginForm />

            <div className="auth-footer">
              <span className="powered-by">{t("authPage.poweredBy")}</span>
              <img
                src={logoEduca.logoE360}
                alt="Educa360"
                className="auth-logo-educa"
              />
            </div>
          </Card>

          <div className="auth-copyright">{t("authPage.copyright")}</div>
        </div>
      </div>
    </ConfigProvider>
  );
}
